import { DateTime } from 'luxon'
import { toMillis } from './chartModel'
import type { StationLeakV0Episode } from './useLeakV0Episodes'

const litreFormatter = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 })
const compactFormatter = new Intl.NumberFormat('en-GB', { notation: 'compact', maximumFractionDigits: 1 })
const percentFormatter = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 })

export const formatLitres = (value: number): string => `${litreFormatter.format(value)} L`

export const formatNullableLitres = (value: number | null): string => (value === null ? '—' : formatLitres(value))

export const formatAxisLitres = (value: number): string => compactFormatter.format(value)

export const formatPercent = (value: number): string => `${percentFormatter.format(value)}%`

const CHART_LOCALE = 'en-GB'

export const formatBucketTime = (atMs: number): string =>
  DateTime.fromMillis(atMs, { locale: CHART_LOCALE }).toFormat('d LLL yyyy HH:mm')

/** The chart's own spelling, so panels beside it read the same instants as the axis and the tooltip. */
export const formatInstant = (iso: string): string => formatBucketTime(toMillis(iso))

export const formatEpisodeRange = (episode: Pick<StationLeakV0Episode, 'onsetAt' | 'clearedAt'>): string =>
  `${formatInstant(episode.onsetAt)} → ${episode.clearedAt === null ? 'ongoing' : formatInstant(episode.clearedAt)}`

// Midnight ticks carry the date and the rest only the time, so the labels stay unambiguous at every
// step below and above a day.
export const formatAxisTime = (atMs: number): string => {
  const at = DateTime.fromMillis(atMs, { locale: CHART_LOCALE })
  return at.hour === 0 && at.minute === 0 ? at.toFormat('d LLL') : at.toFormat('HH:mm')
}
